var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowseFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.799,
    height: 28,
    viewBox: "0 0 37.799 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Folder-Open-Thin--Streamline-Phosphor-Thin",
    d: "M37.561,12.868a2.079,2.079,0,0,0-1.7-.875h-3.5v-3.5a2.1,2.1,0,0,0-2.1-2.1H17.893l-5.04-3.78a2.109,2.109,0,0,0-1.26-.42H2.26a2.1,2.1,0,0,0-2.1,2.1v25.2a.7.7,0,0,0,.7.7H32.2a.7.7,0,0,0,.663-.479L37.85,14.756a2.076,2.076,0,0,0-.289-1.888ZM2.26,3.593h9.333a.7.7,0,0,1,.42.14l5.227,3.92a.7.7,0,0,0,.42.14h12.6a.7.7,0,0,1,.7.7v3.5H7.468a2.1,2.1,0,0,0-1.992,1.437L1.56,25.179V4.293a.7.7,0,0,1,.7-.7Zm34.261,10.72L31.695,28.792H1.831L6.81,13.872a.7.7,0,0,1,.658-.479H35.86a.7.7,0,0,1,.663.921Z",
    transform: "translate(-0.16 -2.193)",
    fill: "#f79420"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseFile);
export default __webpack_public_path__ + "static/media/browse-file.8b609d2ac2c261d37338425df8d88d16.svg";
export { ForwardRef as ReactComponent };